module.exports = __webpack_public_path__ + "img/antiHipThrustText1.2ba0e46e.png";